const storage_key_prefix = ''
export const storage_key = {
  lang: `${storage_key_prefix}lang`,
  indexPopup: `${storage_key_prefix}INDEX_POPUP_VISIBLE`,
}


// WEBPACK FOOTER //
// ./src/config/constant.js